module.exports = __webpack_public_path__ + "static/media/bg-our-branch.b9aa50e2.jpg";